"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectsForWarehouseRole = void 0;
var projectsList_1 = require("common/global/projectsList");
var userProjectRolesList_1 = require("common/global/userProjectRolesList");
var lodash_1 = require("lodash");
var map_1 = __importDefault(require("lodash/map"));
var projectsForWarehouseRole = function (warehouseId, role) {
    var perm = (0, lodash_1.uniq)((0, lodash_1.flatMap)(userProjectRolesList_1.globalUserProjectRolesData
        .filter(function (x) { return x.warehouseId === warehouseId; })
        .filter(function (doc) {
        var _a;
        return ((_a = doc.role) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (role === null || role === void 0 ? void 0 : role.toLowerCase());
    }), function (role) {
        if (!role.projectId) {
            return (0, map_1.default)(projectsList_1.globalProjectsData, function (x) { return x.id; });
        }
        return [role.projectId];
    }));
    if (perm.some(function (x) { return !x; })) {
        return (0, map_1.default)(projectsList_1.globalProjectsData, function (x) { return x.id; });
    }
    return perm;
};
exports.projectsForWarehouseRole = projectsForWarehouseRole;
